import { useStore } from '@/stores/index'
import axios from 'axios'

const requestHeaders = {
  'Content-Type': 'application/json;charset=UTF-8',
}

const isError = (error) => { 
  if (!error) return
  throw createError({ data: error.data, statusCode: error.statusCode, fatal: true })
}

// 共通API通信 functions

export const GET = async (url, options) => { 
  const runtimeConfig = useRuntimeConfig()

  const { data, pending, error, refresh } = await useFetch(url, {
    method: 'get',
    baseURL: runtimeConfig.public.apiUrl,
    headers: requestHeaders,
    ...options
  })

  isError(error.value)
  return data.value
} 


export const POST = async (url, options) => { 
  const runtimeConfig = useRuntimeConfig()

  const { data, pending, error, refresh } = await useFetch(url, {
    method: 'post',
    baseURL: runtimeConfig.public.apiUrl,
    headers: requestHeaders,
    ...options
  })

  isError(error.value)
  return data.value
} 


export const PUT = async (url, options) => { 
  const runtimeConfig = useRuntimeConfig()

  const { data, pending, error, refresh } = await useFetch(url, {
    method: 'put',
    baseURL: runtimeConfig.public.apiUrl,
    headers: requestHeaders,
    ...options
  })

  isError(error.value)
  return data.value
} 


export const DELETE = async (url, options) => { 
  const runtimeConfig = useRuntimeConfig()

  const { data, pending, error, refresh } = await useFetch(url, {
    method: 'delete',
    baseURL: runtimeConfig.public.apiUrl,
    headers: requestHeaders,
    ...options
  })
  isError(error.value)
  return data.value
} 

export const IMPGET = async (url, options) => {
  const runtimeConfig = useRuntimeConfig()
  const rootStore = useStore()
  const impressionKey = CHECKIMPKEY()

  const apiImp = axios.create({
    baseURL: runtimeConfig.public.impUrl,
    headers: {
      get: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
    },
  })
  
  apiImp.interceptors.request.use(
    (config) => {
      // 必須パラメータの付与
      config.params.key = impressionKey
      config.params.media = rootStore.mediaId

      return config
    },
    (err) => {
      console.log(err)
    },
  )
  
  apiImp.interceptors.response.use(
    res => {
      return res
    },
    err => {
      // eslint-disable-next-line no-console
      console.log(err)
    }
  )

  return apiImp.get(url, options)
} 

export const IMPPV = async (url, options) => {
  const runtimeConfig = useRuntimeConfig()
  const rootStore = useStore()
  const impressionKey = CHECKIMPKEY()

  const apiImp = axios.create({
    baseURL: runtimeConfig.public.impPvUrl,
    headers: {
      get: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
    },
  })
  
  apiImp.interceptors.request.use(
    (config) => {
      // 必須パラメータの付与
      config.params.key = impressionKey
      config.params.media = rootStore.mediaId

      return config
    },
    (err) => {
      console.log(err)
    },
  )
  
  apiImp.interceptors.response.use(
    res => {
      return res
    },
    err => {
      // eslint-disable-next-line no-console
      console.log(err)
    }
  )

  return apiImp.get(url, options)
} 